import { useEffect, useId, useRef, useState } from 'react'
import styles from './Select.module.scss'

const ponderaOptions = [
	{ value: '0.1', label: '0,1' },
	{ value: '0.2', label: '0,2' },
]

export default function PonderaSelect({ name }) {
	const [open, setOpen] = useState(false)
	const [value, setValue] = useState(ponderaOptions[0].value)
	const selectRef = useRef(null)
	const listboxId = useId()
	const selectedOption = ponderaOptions.find((option) => option.value === value) ?? ponderaOptions[0]

	useEffect(() => {
		const handlePointerDown = (event) => {
			if (!selectRef.current?.contains(event.target)) {
				setOpen(false)
			}
		}
		const handleKeyDown = (event) => {
			if (event.key === 'Escape') {
				setOpen(false)
			}
		}

		document.addEventListener('mousedown', handlePointerDown)
		document.addEventListener('keydown', handleKeyDown)
		return () => {
			document.removeEventListener('mousedown', handlePointerDown)
			document.removeEventListener('keydown', handleKeyDown)
		}
	}, [])

	useEffect(() => {
		const form = selectRef.current?.closest('form')
		if (!form) return undefined

		const handleReset = () => {
			setValue(ponderaOptions[0].value)
			setOpen(false)
		}

		form.addEventListener('reset', handleReset)
		return () => form.removeEventListener('reset', handleReset)
	}, [])

	const handleOption = (optionValue) => {
		setValue(optionValue)
		setOpen(false)
	}

	const handleButtonKeyDown = (event) => {
		if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
			event.preventDefault()
			const currentIndex = ponderaOptions.findIndex((option) => option.value === value)
			const direction = event.key === 'ArrowDown' ? 1 : -1
			const nextIndex = (currentIndex + direction + ponderaOptions.length) % ponderaOptions.length
			setValue(ponderaOptions[nextIndex].value)
			setOpen(true)
		}
	}

	return (
		<div className={styles.select} ref={selectRef} data-open={open ? 'true' : 'false'}>
			<input type='hidden' name={name} value={value} />
			<button
				type='button'
				className={styles.selectButton}
				aria-haspopup='listbox'
				aria-expanded={open}
				aria-controls={listboxId}
				onClick={() => setOpen((currentOpen) => !currentOpen)}
				onKeyDown={handleButtonKeyDown}
			>
				<span>{selectedOption.label}</span>
			</button>
			<ul className={styles.options} id={listboxId} role='listbox' aria-label='Ponderacio'>
				{ponderaOptions.map((option) => (
					<li key={option.value} role='option' aria-selected={option.value === value}>
						<button type='button' tabIndex={open ? 0 : -1} onClick={() => handleOption(option.value)}>
							{option.label}
						</button>
					</li>
				))}
			</ul>
		</div>
	)
}
